
import React, { PropsWithChildren } from 'react';
import { MappedComponentProperties } from '@adobe/aem-react-editable-components';
import { transformHTMLParserLinks } from '../../utils/rewriteLink/rewriteLink';

import './MidPageNavigationIcons.css';
import { Icon } from '../../types/models/Icon';
import { cleanInternalLinkUrl } from '../../utils/cob-utils';
import TextLine from '../../component-library/atoms/TextLine';

const DEFAULT_NAV_ICON_WIDTH = 48;
const DEFAULT_NAV_ICON_HEIGHT = 48;

interface navigationItem {
    icon?: Icon,
    iconAltText?: string,
    title?: string,
    description?: string,
    linkUrl?: string
}

interface IMidPageNavigationIconsProps extends MappedComponentProperties {
    header?: string,
    backgroundColor?: 'white' | 'grey',
    navigationItems?: navigationItem[],
}

export const MidPageNavigationIconsEditConfig = {
    emptyLabel: 'Mid Page Navigation Icons',
    isEmpty: (props: PropsWithChildren<IMidPageNavigationIconsProps>) => {
        return !props.header || !(props?.navigationItems?.length > 0);
    },
};

const MidPageNavigationIcons = (props: PropsWithChildren<IMidPageNavigationIconsProps>): JSX.Element => {
    return (
        <div className={'MidPageNavigationIcons' + (props.backgroundColor === 'grey' ? ' bg-grey-alabaster' : '')}>
            <TextLine 
                className='MidPageNavigationIcons__header'
                textClass='font-bold pl-2'
                variant='author'>
                {props.header}
            </TextLine>
            <div className='MidPageNavigationIcons__container'>
                {props?.navigationItems?.map((item, index) => {
                    return (
                        <a href={cleanInternalLinkUrl(item?.linkUrl + '.html')} className='MidPageNavigationIcons__item' key={index}>
                            <img
                                className='MidPageNavigationIcons__icon'
                                src={item?.icon?.iconPath}
                                alt={item?.iconAltText}
                                loading='lazy'
                                width={DEFAULT_NAV_ICON_WIDTH}
                                height={DEFAULT_NAV_ICON_HEIGHT}
                            />
                            <div className='MidPageNavigationIcons__text'>
                                <h5 className='MidPageNavigationIcons__itemTitle'>{item?.title}</h5>
                                {item?.description && 
                                    <div className='MidPageNavigationIcons__itemDescription'>{transformHTMLParserLinks(item.description)}</div>
                                }
                            </div>
                        </a>
                    );
                })}
            </div>
        </div>
    );
};

export default MidPageNavigationIcons;
        
